const selectCampaignTypeOptions = [
  {
    id: 1,
    name: 'E-mail',
    buy: true,
    searchCampaign: true,
    communication: false,
    config: false,
  },
  {
    id: 2,
    name: 'SMS',
    buy: true,
    searchCampaign: true,
    communication: true,
    config: true,
  },
  {
    id: 3,
    name: 'WhatsApp Web',
    buy: false,
    searchCampaign: false,
    communication: true,
    config: false,
  },
];

export default selectCampaignTypeOptions;
